"use client";

import { useEffect } from "react";
import { getSessionData } from "@repo/shared-utils/common-utils";
import {
  selectIsAuthSuccessOrPerpetual,
  useAppSelector,
} from "@repo/web-store";
import { saveIndicesData } from "../../services/TradingMallService";

interface LastVisitedWrapperProps {
  symbol: string;
}

const LastVisitedWrapper = ({ symbol }: LastVisitedWrapperProps) => {
  const isAuthSuccessOrPerpetual = useAppSelector(
    selectIsAuthSuccessOrPerpetual,
  );

  useEffect(() => {
    const saveLastVisited = async () => {
      try {
        const { mobileNo } = await getSessionData();
        if (!mobileNo || !symbol) return;

        await saveIndicesData({ mobileNo, lastVisited: [symbol] });
      } catch {
        // Silent fail: last-visited save must never break the page.
      }
    };

    saveLastVisited();
  }, [isAuthSuccessOrPerpetual, symbol]);

  return null;
};

export default LastVisitedWrapper;
